import { render, staticRenderFns } from "./settlement-purchase-summary.vue?vue&type=template&id=527905fe&scoped=true"
import script from "./settlement-purchase-summary.vue?vue&type=script&lang=js"
export * from "./settlement-purchase-summary.vue?vue&type=script&lang=js"
import style0 from "./settlement-purchase-summary.vue?vue&type=style&index=0&id=527905fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527905fe",
  null
  
)

export default component.exports